export default __webpack_public_path__ + "static/media/forest.792d903a.jpg";